import React from "react";
import { Glyphicon } from "react-bootstrap";

import styles from "./SearchBox.scss";

class SearchBox extends React.Component {
  static defaultProps = {
    positionClass: null
  };

  state = {
    value: ""
  };

  change(value) {
    const { onChange } = this.props;

    this.setState({
      ...this.state,
      value
    });

    onChange(value);
  }

  clear() {
    this.change("");
  }

  render() {
    const { positionClass } = this.props;

    const { value } = this.state;

    return (
      <div className={styles.searchBox}>
        {positionClass && <div class={`${styles.arrow} ${positionClass}`} />}

        <Glyphicon glyph="search" className={styles.icon} />
        <input
          type="text"
          className={styles.input}
          value={value}
          onChange={event => this.change(event.target.value)}
        />

        <div className={styles.divider} />

        <button type="button" className={styles.clear}>
          Clear
        </button>
      </div>
    );
  }
}

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/common/searchBox/SearchBox.js